import React from "react";
import { Popper } from "@remo-co/ui-core/src/components/Popper";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { Button } from "@remo-co/ui-core/src/components/Button";
import { Card } from "@remo-co/ui-core/src/components/Card";
import { Container } from "@remo-co/ui-core/src/components/Container";
import { Info } from "@remo-co/ui-core/src/icons/Info";
import { useCompanyPlanSettings } from "modules/companyPlanSettings";
import { useI18n } from "i18n";
import UpgradePlanButton from "modules/settings/plans/UpgradePlanButton";
import { useStyles } from "./styles";

interface IUpsellPopoverProps {
  containerRef: React.MutableRefObject<HTMLButtonElement | null>;
  isVisible: boolean;
  closePopover: () => void;
}

const UpsellPopover = ({
  containerRef,
  isVisible,
  closePopover,
}: IUpsellPopoverProps) => {
  const { t } = useI18n(["common", "settings", "eventDirectory"]);
  const { getDirectoryLimit } = useCompanyPlanSettings();
  const companyDirectoryLimit = getDirectoryLimit();
  const styles = useStyles();

  return (
    <Popper
      anchorEl={containerRef.current}
      popperOptions={{
        modifiers: [
          {
            name: "offset",
            enabled: true,
            options: {
              offset: [0, 10],
            },
          },
          {
            name: "arrow",
            enabled: true,
          },
        ],
      }}
      placement="right"
      open={isVisible}
      disablePortal
      className={styles.popover}
    >
      <Card size="xs" flex fullWidth={false} className={styles.card}>
        <Container
          flex
          column
          justifyContent="flex-start"
          className={styles.cardContent}
        >
          <Container flex justifyContent="flex-start">
            <Info className={styles.infoIcon} />
            <Typography
              variant="h5"
              color="textPrimary"
              className={styles.title}
            >
              {t("eventDirectory:directory.limit.reached")}
            </Typography>
          </Container>
          <Typography
            variant="body1"
            color="textPrimary"
            className={styles.description}
          >
            {companyDirectoryLimit === 1
              ? t(
                  "eventDirectory:directory.limit.reached.description.limit.one",
                )
              : t("eventDirectory:directory.limit.reached.description", {
                  number: companyDirectoryLimit,
                })}
          </Typography>
          <Container flex justifyContent="flex-end">
            <Button
              size="xs"
              variant="secondary"
              color="dark"
              className={styles.buttons}
              contentClassName={styles.buttonContent}
              onClick={closePopover}
            >
              {t("common:button.cancel")}
            </Button>
            <UpgradePlanButton
              size="xs"
              className={styles.buttons}
              contentClassName={styles.buttonContent}
            />
          </Container>
        </Container>
      </Card>
    </Popper>
  );
};

export default UpsellPopover;
